/* eslint-disable no-case-declarations */
import React from 'react';
import parse from 'html-react-parser';
import { useParams } from 'react-router-dom';
import { subjectTypes } from '../../@types/entities/subjects.entity';

import extractObjectFromTable from '../../utils/extract-object-table';
import getImageArray from '../../utils/get-image-array';

import GamesAndPlay from '../games-and-play';
import NextClass from '../next-class';
import Quotations from '../quotation-component';
import Attachment from '../attachment';
import Highlight from '../box-highlight';
import MediaPlayer from '../media-player';
import ProjectBox from '../projects-components';
import ReminderBox from '../reminder-box';
import Image, { IImage } from '../image';
import CustomGallery from '../image-gallery';

const componentRenderer = (child: Element) => {
  const { materia } = useParams();

  if (!materia) return <>Matéria não encontrada</>;

  const MATERIA = materia as subjectTypes;
  const key = child.classList[0];

  const content = child.querySelectorAll('p, ul');
  const tablecontent = child.querySelectorAll('table');
  const isObject = !['p', 'ul'].includes(child.tagName.toLowerCase());
  const stringContent = isObject
    ? Array.from(content)
        .map((element) => element.outerHTML)
        .join('')
    : child.outerHTML;

  const tableContentIsObject = !['table'].includes(child.tagName.toLowerCase());
  const stringTableContent = tableContentIsObject
    ? Array.from(tablecontent)
        .map((element) => element.outerHTML)
        .join('')
    : child.outerHTML;

  const formattedString = stringContent.replaceAll(/-/g, '‑');

  const componentObject = extractObjectFromTable(child);

  switch (key) {
    case 'boxLembrete':
      return <ReminderBox subject={MATERIA} content={formattedString} />;
    case 'midiaImagem':
      return (
        <CustomGallery
          images={componentObject as IImage}
        />
      );
    case 'galeriaImagens':
      const images = getImageArray(child) as IImage[];
      return (
        <CustomGallery
          images={images}
        />
      );
    case 'secaoJogosBrincadeiras':
      return (
        <GamesAndPlay content={formattedString} subject={MATERIA} color={50} />
      );
    case 'secaoProximaAula':
      return (
        <NextClass
          title="Para a próxima aula"
          content={formattedString}
          subject={MATERIA}
        />
      );
    case 'citacao':
      return (
        <Quotations
          content={formattedString}
          font=""
          title=""
          subject={MATERIA}
        />
      );
    case 'anexo':
      return (
        <Attachment
          path={componentObject['nome_do_arquivo_(com_extensao)']}
          label={componentObject.texto_para_download}
          subject={MATERIA}
        />
      );
    case 'midiaAudio':
    case 'midiaVideo':
      return <MediaPlayer retranca={componentObject.retranca} type={key} />;
    case 'boxDestaque':
      return <Highlight subject={MATERIA}>{formattedString}</Highlight>;
    case 'secaoExperimentoteca':
    case 'secaoMaosNaMatematica':
    case 'secaoRodaGigante':
      return <ProjectBox componentType={key} object={stringTableContent} />;
    default:
      return parse(stringContent.replace(/-/g, '‑'));
  }
};

export default componentRenderer;
